import {Input, Type} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {FormValueModel} from '../../../../../modules/form/form/value/api/entity/formValue.model';
import {AbstractFieldInputTypeHandlerComponent} from "./abstract-field-input-type-handler.component";

export interface IFieldInputTypeHandler {
    fieldFormGroup: UntypedFormGroup;
    formValue: FormValueModel;
}
export class FieldInputTypeHandlerRegister {
    private static classes: Map<string, Type<AbstractFieldInputTypeHandlerComponent<any>>> = new Map();
    static register(clazz: Type<AbstractFieldInputTypeHandlerComponent<any>>, typeValue: string, subTypeValue: string) {
        // console.log(['FieldInputJsonHandlerRegister: register ', clazz, fieldNames, FieldInputJsonHandlerRegister.classes]);
        const key = this.buildKey(typeValue, subTypeValue);
        if (!this.getImplementation(typeValue, subTypeValue)) {
            FieldInputTypeHandlerRegister.classes.set(key, clazz);
        }
    }
    static getImplementation(typeValue: string, subTypeValue: string): Type<AbstractFieldInputTypeHandlerComponent<any>> {
        return FieldInputTypeHandlerRegister.classes.get(this.buildKey(typeValue, subTypeValue));
    }

    private static buildKey(typeValue: string, subTypeValue: string) {
        return typeValue + '____' + subTypeValue;
    }
}
